module.exports = __webpack_public_path__ + "static/media/arrow-right-outline-color.a3092500.svg";